import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartData
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import styled from '@xstyled/styled-components';
import { Item, registry, RenderProps } from '../Item';
import { CHART_BAR } from '../itemIds';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface ItemDef {
  title: string;
  subtitle: string;
  body: string;
}

interface Props {
  title?: string;
  subtitle?: string;
  items: Array<ItemDef>;
}

const Wrapper = styled.divBox`
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  padding-bottom: 30px;
  width: 100%;
`;

export class ChartBar extends Item<typeof CHART_BAR, Props> {
  protected render({ title, subtitle, items }: RenderProps<Props>) {
    const labels: string[] = [];
    const ariaLabel: string[] = [];

    const options = {
      responsive: true,
      plugins: {
        legend: {
          position: 'top' as const,
          interaction: {
            mode: false,
            intersect: false
          },
          onHover: (_event: unknown) => {
            return false;
          },
          onClick: (_event: unknown) => {
            return false;
          }
        },
        tooltip: {
          enabled: false
        }
      }
    };

    const dataSets: Record<string, unknown>[] = [];

    if (items && items.length) {
      items.forEach((item: ItemDef, index) => {
        labels.push('');
        ariaLabel.push(`${item?.title} ${item?.subtitle.split('|')[0]}%`);

        const colors = item?.body?.replace(/<\/?[^>]+(>|$)/g, '')?.split(',');

        dataSets.push({
          label: item?.title,
          data: item?.subtitle.split('|'),
          backgroundColor:
            colors && colors[0] ? colors[0] : 'rgba(255, 99, 132, 0.5)'
        });
      });
    }

    const data = { labels, datasets: dataSets } as unknown as ChartData<'bar'>;

    return (
      <Wrapper>
        <Bar
          options={options}
          data={data}
          aria-label={ariaLabel.join(', ')}
          role="img"
        />
      </Wrapper>
    );
  }
}

registry[CHART_BAR] = ChartBar;
